import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-12f59ea6")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "p-d-flex p-flex-column p-jc-center" }
const _hoisted_3 = {
  class: "p-d-flex p-jc-center",
  style: {"margin-right":"8%","margin-top":"2%"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "p-d-flex p-jc-center",
  style: {"margin-left":"8%"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "home-menu" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "welcome-text" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "¿Cuál es tu área de trabajo?")
], -1)
const _hoisted_10 = { class: "p-d-flex p-jc-evenly" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkAreaCard = _resolveComponent("WorkAreaCard")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/icons/home/coder-word-logo.svg'),
          alt: "Coder",
          style: {"width":"14%"}
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: require('@/assets/icons/home/brain-word-logo.svg'),
          alt: "Brain",
          style: {"width":"17%"}
        }, null, 8, _hoisted_6),
        _createElementVNode("img", {
          src: require('@/assets/icons/home/brain.svg'),
          alt: "Brain logo",
          style: {"width":"6%"}
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_component_WorkAreaCard, {
            key: option,
            id: option.id,
            title: option.title,
            visible: option.visible,
            img: option.img,
            to: option.to
          }, null, 8, ["id", "title", "visible", "img", "to"]))
        }), 128))
      ]),
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/recruitment/structure'))),
        class: "p-button-outlined p-button-info organigrama-button",
        label: "Organigrama"
      })
    ])
  ]))
}